import {
  CORE_LOAD_AMENITYACTIVE_REQUEST,
  CORE_LOAD_AMENITYACTIVE_SUCCESS,

  CORE_LOAD_AMENITYPAST_REQUEST,
  CORE_LOAD_AMENITYPAST_SUCCESS,

  CORE_LOAD_AMENITYNEXT_REQUEST,
  CORE_LOAD_AMENITYNEXT_SUCCESS,

  CORE_LOAD_FOODACTIVE_REQUEST,
  CORE_LOAD_FOODACTIVE_SUCCESS,

  CORE_LOAD_FOODPAST_REQUEST,
  CORE_LOAD_FOODPAST_SUCCESS,

  CORE_LOAD_FOODNEXT_REQUEST,
  CORE_LOAD_FOODNEXT_SUCCESS,

  CORE_SENDAMENITY_REQUEST,
  CORE_SENDAMENITY_SUCCESS,

  CORE_SENDFOOD_REQUEST,
  CORE_SENDFOOD_SUCCESS,

  CORE_DONEAMENITY_REQUEST,
  CORE_DONEAMENITY_SUCCESS,

  CORE_DONEFOOD_REQUEST,
  CORE_DONEFOOD_SUCCESS,

  CORE_CANCELEVENTAMENITY_REQUEST,
  CORE_CANCELEVENTAMENITY_SUCCESS,

  CORE_CANCELEVENTFOOD_REQUEST,
  CORE_CANCELEVENTFOOD_SUCCESS,

  CORE_LOAD_EVENTSERVICEAMENITY_REQUEST,
  CORE_LOAD_EVENTSERVICEAMENITY_SUCCESS,

  CORE_LOAD_EVENTSERVICEFBS_REQUEST,
  CORE_LOAD_EVENTSERVICEFBS_SUCCESS,

  CORE_LOAD_EVENTINFOSERVICE_REQUEST,
  CORE_LOAD_EVENTINFOSERVICE_SUCCESS,

} from '../../types'

const initialState = []
export default {
  amenityActive: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_AMENITYACTIVE_REQUEST:
      case CORE_SENDAMENITY_REQUEST:
      case CORE_DONEAMENITY_REQUEST:
      case CORE_CANCELEVENTAMENITY_REQUEST:
        return state
      case CORE_LOAD_AMENITYACTIVE_SUCCESS:
      case CORE_SENDAMENITY_SUCCESS:
      case CORE_CANCELEVENTAMENITY_SUCCESS:
      case CORE_DONEAMENITY_SUCCESS:
        return action.payload
      default:
        return state
    }
  },
  amenityPast: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_AMENITYPAST_REQUEST:
      case CORE_SENDAMENITY_REQUEST:
      case CORE_DONEAMENITY_REQUEST:
      case CORE_CANCELEVENTAMENITY_REQUEST:
        return state
      case CORE_LOAD_AMENITYPAST_SUCCESS:
      case CORE_SENDAMENITY_SUCCESS:
      case CORE_CANCELEVENTAMENITY_SUCCESS:
      case CORE_DONEAMENITY_SUCCESS:
        return action.payload
      default:
        return state
    }
  },
  amenityNext: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_AMENITYNEXT_REQUEST:
      case CORE_SENDAMENITY_REQUEST:
      case CORE_DONEAMENITY_REQUEST:
      case CORE_CANCELEVENTAMENITY_REQUEST:
        return {}
      case CORE_LOAD_AMENITYNEXT_SUCCESS:
      case CORE_SENDAMENITY_SUCCESS:
      case CORE_CANCELEVENTAMENITY_SUCCESS:
      case CORE_DONEAMENITY_SUCCESS:
        return action.payload
      default:
        return state
    }
  },
  foodActive: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_FOODACTIVE_REQUEST:
      case CORE_SENDFOOD_REQUEST:
      case CORE_DONEFOOD_REQUEST:
      case CORE_CANCELEVENTFOOD_REQUEST:
        return state
      case CORE_LOAD_FOODACTIVE_SUCCESS:
      case CORE_SENDFOOD_SUCCESS:
      case CORE_DONEFOOD_SUCCESS:
      case CORE_CANCELEVENTFOOD_SUCCESS:
        return action.payload
      default:
        return state
    }
  },
  foodPast: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_FOODPAST_REQUEST:
      case CORE_SENDFOOD_REQUEST:
      case CORE_DONEFOOD_REQUEST:
      case CORE_CANCELEVENTFOOD_REQUEST:
        return state
      case CORE_LOAD_FOODPAST_SUCCESS:
      case CORE_SENDFOOD_SUCCESS:
      case CORE_DONEFOOD_SUCCESS:
      case CORE_CANCELEVENTFOOD_SUCCESS:
        return action.payload
      default:
        return state
    }
  },
  foodNext: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_FOODNEXT_REQUEST:
      case CORE_SENDFOOD_REQUEST:
      case CORE_DONEFOOD_REQUEST:
      case CORE_CANCELEVENTFOOD_REQUEST:
        return {}
      case CORE_LOAD_FOODNEXT_SUCCESS:
      case CORE_SENDFOOD_SUCCESS:
      case CORE_DONEFOOD_SUCCESS:
      case CORE_CANCELEVENTFOOD_SUCCESS:
        return action.payload
      default:
        return state
    }
  },
  orderInfoService: (state = {}, action = {}) => {
    switch (action.type) {
      case CORE_LOAD_EVENTINFOSERVICE_REQUEST:
        return {}
      case CORE_LOAD_EVENTINFOSERVICE_SUCCESS:
        return action.payload
      default:
        return state
    }
  },
  orderAmenityList: (state = [], action = {}) => {
    switch (action.type) {
      case CORE_LOAD_EVENTSERVICEAMENITY_REQUEST:
        return []
      case CORE_LOAD_EVENTSERVICEAMENITY_SUCCESS:
        return action.payload
      default:
        return state
    }
  },
  orderFbsList: (state = [], action = {}) => {
    switch (action.type) {
      case CORE_LOAD_EVENTSERVICEFBS_REQUEST:
        return []
      case CORE_LOAD_EVENTSERVICEFBS_SUCCESS:
        return action.payload
      default:
        return state
    }
  },
}


// WEBPACK FOOTER //
// ./src/front/features/amenityandservice/reducer.js